import { IDataFlowPOParser } from './IDataFlowPOParser';
import { RemoteDataFlowPOParser } from './remote.dataFlowPO.parser';
import { LocalDataFlowPOParser } from './local.dataFlowPO.parser';
import { ParsingStrategy } from './dataflowPO.parser.models';

export class DataFlowPOParserFactory {
    public static createInstance(parsingStrategy: ParsingStrategy = ParsingStrategy.Remote): IDataFlowPOParser {
        return parsingStrategy === ParsingStrategy.Remote
            ? new RemoteDataFlowPOParser()
            : new LocalDataFlowPOParser();
    }
}
